<div style="padding: 1em; height: 100%;" [ngClass]="{'darkMode': darkMode, 'glassMode': glassMode}">
  <lib-new-table-editor #mainLogs
    modelName="Starbase One Application Logs"
    (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
    [userViewOptions]="logUserViewOptions"
    [usePagination]="true"
    [loadAllClientside]="false"
    [dataFilterParams]="logFilterParams"
    [tableEditable]="false"
    [dataSvc]="logDataSvc"
    [rppChoices]="[10, 15, 25, 50, 100]"
    [tableHeight]="'75vh'"
    [columns]="logCols"
    [darkMode]="darkMode"
    [glassMode]="glassMode">
    <h3 class="Starbase-Title-Font">
      <i class="fal fa-lg fa-starship"></i>
      {{ appGlobals.oneSiteMode ? appGlobals.site.siteCode : appGlobals.appTitle }} Application Logs <br>
      <lib-log-search #logSearch
        (searchOutput)="searchTyping($event)"
        (errorOutput)="handleSearchError($event)"
        (resultsOutput)="quickSearchLogs($event)"
        [darkMode]="darkMode"
        [glassMode]="glassMode"></lib-log-search>
      <ng-container *ngTemplateOutlet="logLevelsDropdown"></ng-container>
    </h3>
    <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="logCols" let-compactMode="compactMode">
      <span style="display: contents;" lib-table-row
        [ngClass]="{'errorRow': rowData.level === 'Error', 'fatalRow': rowData.level === 'Fatal'}"
        [rowData]="rowData"
        [columnDefinitions]="logCols"
        [allowEdit]="false"
        [compactMode]="compactMode">
      </span>
    </ng-template>
    <span footerRow class="footerRow">
      <td [ngClass]="{'darkMode': darkMode, 'glassMode': glassMode}" title="Requires admin">
        <label for="showExceptChk" class="fieldLabel">
          Show exceptions
        </label>
      </td>
      <td>
        <label class="switch">
          <input type="checkbox" id="showExceptChk" (click)="toggleExceptions()" [(ngModel)]="showExceptions"><span class="slider round"></span>
        </label>
      </td>
      <td></td>
    </span>
  </lib-new-table-editor>
</div>

<ng-template #logLevelsDropdown>
  <div class="btn-group dropdown ms-2"  style="vertical-align: baseline;" matTooltip="Filter by Log Levels">
    <button type="button" id="llDropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-sm dropdown-toggle" [ngClass]="{'btn-dark': darkMode, 'btn-outline-secondary': !darkMode}">
      <span class="badge bg-dark" style="line-height: 1.25em;" *ngIf="currentLogLevelFiltersSet.length">{{ currentLogLevelFiltersSet.length }}</span>
      Log Levels
    </button>
    <div class="dropdown-menu" [ngClass]="{'darkMode': darkMode, 'glassMode': glassMode}" style="max-height: 200px; overflow: auto;" aria-labelledby="ctDropupMenu">
      <button class="dropdown-item" [ngClass]="{'disabled': !currentLogLevelFiltersSet.length}"
        (click)="clearLogLevelFilters()">
        Clear this filter
      </button>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" [ngClass]="{'darkMode': darkMode, 'glassMode': glassMode}" *ngFor="let ll of logLevels" (click)="updateLogLevelFilters(ll)">
        <i class="fal fa-check me-1" *ngIf="currentLogLevelFiltersSet.includes(ll)"></i>
        <span [ngClass]="{'errorRow': ll === 'Error', 'fatalRow': ll === 'Fatal'}">{{ ll }}</span>
      </a>
    </div>
  </div>
</ng-template>
